<template>
    <div v-loading="isLoading">
        <div class="form-row">
            <div class="form-group col-xl-4">
                <label class="mb-0" for="car_form_brand_name">Марка</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_brand_name"
                             :loading="loadings.brands"
                             :disabled="loadings.brands"
                             v-model="brand_name"
                             :options="brand_select"
                             @tag="addTagBrand"
                             @input="onChangeBrand"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="true"
                >
                </multiselect>
                <has-error :form="form" field="brand_name" class="d-block"/>
            </div>
            <div class="form-group col-xl-4">
                <label class="mb-0" for="car_form_model_name">Модель</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_model_name"
                             :loading="loadings.models"
                             :disabled="loadings.models"
                             v-model="model_name"
                             :options="model_select"
                             @tag="addTagModel"
                             @input="onChangeModel"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="!!brand_name"
                >
                </multiselect>
                <has-error :form="form" field="model_name" class="d-block"/>
            </div>
            <div class="form-group col-xl-4">
                <label class="mb-0" for="car_form_generation_name">Поколение</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_generation_name"
                             :loading="loadings.generations"
                             :disabled="loadings.generations"
                             v-model="generation_temp"
                             :options="generation_select"
                             @tag="addTagGeneration"
                             @input="onChangeGeneration"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="!!brand_name && !!model_name" track-by="id" label="title"
                >
                    <template slot="option" slot-scope="props">
                        <span v-if="props.option.label" class="option__title">{{props.option.label}}</span>
                        <span v-if="props.option.$groupLabel" class="option__title">{{props.option.$groupLabel}}</span>
                        <span v-if="props.option.title" class="option__title">{{ props.option.title }}</span>

                        <a v-if="props.option.id && props.option.year_from" class="small text-muted ml-2">({{props.option.year_from}}-{{props.option.year_to}})</a>
                    </template>
                </multiselect>
                <has-error :form="form" field="generation_name" class="d-block"/>
            </div>
            <div class="form-group col-xl-3">
                <label class="mb-0" for="car_form_pts_year">Год</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_pts_year"
                             :loading="loadings.years"
                             :disabled="loadings.years"
                             v-model="pts_year"
                             :options="year_select"
                             @tag="addTagYear"
                             @input="onChangeYear"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="!!brand_name && !!model_name && !!generation_name"
                >
                </multiselect>
                <has-error :form="form" field="pts_year" class="d-block"/>
            </div>
            <div class="form-group col-xl-3">
                <label class="mb-0" for="car_form_body_type">Кузов</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_body_type"
                             :loading="loadings.bodies"
                             :disabled="loadings.bodies"
                             v-model="body_type"
                             :options="body_select"
                             @tag="addTagBody"
                             @input="onChangeBody"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="!!brand_name && !!model_name && !!generation_name && !!pts_year"
                >
                </multiselect>
                <has-error :form="form" field="body_type" class="d-block"/>
            </div>
            <div class="form-group col-xl-3">
                <label class="mb-0" for="car_form_modification_name">Модификация</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_modification_name"
                             :loading="loadings.modifications"
                             :disabled="loadings.modifications"
                             v-model="modification_temp"
                             :options="modification_select"
                             @tag="addTagModification"
                             @input="onChangeModification"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="!!brand_name && !!model_name && !!generation_name && !!pts_year && !!body_type" track-by="id" label="name"
                >
                </multiselect>
                <has-error :form="form" field="modification_name" class="d-block"/>
            </div>
            <div class="form-group col-xl-3">
                <label class="mb-0" for="car_form_complectation_name">Комплектация</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_complectation_name"
                             :loading="loadings.complectations"
                             :disabled="loadings.complectations"
                             v-model="complectation_name"
                             :options="complectation_select"
                             @tag="addTagComplectation"
                             @input="onChangeComplectation"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="!!brand_name && !!model_name && !!generation_name && !!pts_year && !!modification_name"
                >
                </multiselect>
                <has-error :form="form" field="complectation_name" class="d-block"/>
            </div>
            <div class="form-group col-xl-2">
                <label class="mb-0" for="car_form_gearbox_type">КПП</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_gearbox_type"
                             v-model="gearbox_type"
                             :options="gearbox_type_select"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="true"
                ></multiselect>
                <has-error :form="form" field="gearbox_type" class="d-block"/>
            </div>
            <div class="form-group col-xl-2">
                <label class="mb-0" for="car_form_drive_type">Привод</label>
                <multiselect class="multiselect-bootstrap"
                             id="car_form_drive_type"
                             v-model="drive_type"
                             :options="drive_type_select"
                             placeholder="" :close-on-select="true" :clear-on-select="false" :taggable="true" :selectedLabel="''"  :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false" :searchable="true"
                ></multiselect>
                <has-error :form="form" field="drive_type" class="d-block"/>
            </div>
            <div class="form-group col-xl-3">
                <div class="custom-controls-stacked">
                    <label class="custom-control custom-radio custom-control-inline mb-2">
                        <input name="condition" type="radio" class="custom-control-input" value="new" v-model="condition">
                        <span class="custom-control-label">Новый</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline mb-0">
                        <input name="condition" type="radio" class="custom-control-input" value="used" v-model="condition">
                        <span class="custom-control-label">Подержанный</span>
                    </label>
                </div>
                <has-error :form="form" field="condition" class="d-block"/>
            </div>
            <div class="form-group col-xl-2"><label class="mb-0" for="car_form_mileage">Пробег</label><input type="text" class="form-control" id="car_form_mileage" v-model="mileage"><has-error :form="form" field="mileage" class="d-block"/></div>
            <div class="form-group col-xl-3">
                <label class="mb-0">VIN</label>
                <input type="text" class="form-control" :class="{'is-invalid': vinFormatError}" :id="'car_form_pts_vin' + _uid" v-model="pts_vin" :disabled="vin_type === 'absent'" :placeholder="vin_type === 'absent' ? 'ОТСУТСТВУЕТ' : ''" @input="onVinInput">
                <div class="btn-group btn-group-sm btn-group-toggle d-flex mt-1" data-toggle="buttons">
                    <label class="btn btn-outline-gray" :class="{active: vin_type === 'vin'}">
                        <input type="radio" value="vin" v-model="vin_type"> VIN
                    </label>
                    <label class="btn btn-outline-gray" :class="{active: vin_type === 'absent'}">
                        <input type="radio" value="absent" v-model="vin_type"> Отсутствует
                    </label>
                    <label class="btn btn-outline-gray" :class="{active: vin_type === 'other'}">
                        <input type="radio" value="other" v-model="vin_type"> Другой
                    </label>
                </div>
                <div v-if="vinFormatError" class="text-danger small mt-1">{{ vinFormatError }}</div>
                <has-error :form="form" field="pts_vin" class="d-block"/>
            </div>
            <div class="form-group col-xl-2">
                <label class="mb-0" :for="'car_form_cost' + _uid">Стоимость</label><HelpPopover about="Стоимость автомобиля" />
                <input type="text" readonly class="form-control-plaintext" :id="'car_form_cost' + _uid" :value="(cost / 100) | formatNumber">
            </div>
            <div v-if="$hasPermissionInterface('car.form.cost_accumulated')" class="form-group col-xl-3">
                <label class="mb-0" :for="'car_form_cost_accumulated' + _uid">Накопленная стоимость</label><HelpPopover about="Накопленная стоимость автомобиля" />
                <input type="text" readonly class="form-control-plaintext" :id="'car_form_cost_accumulated' + _uid" :value="(cost_accumulated / 100) | formatNumber">
            </div>
            <div v-if="$hasPermissionInterface('car.form.cost_increase')" class="form-group col-xl-2">
                <label class="mb-0" :for="'car_form_cost_increase' + _uid">Удорожание</label>
                <input type="number" min="0" class="form-control" :id="'car_form_cost_increase' + _uid" v-model="cost_increase">
                <has-error :form="form" field="cost_increase" class="d-block"/>
            </div>
        </div>
        <el-tabs v-model="tab_active" class="mt-3" :tab-position="'top'">
            <el-tab-pane name="default" label="Основное">
                <div class="form-row">
                    <div class="form-group col-xl-4">
                        <label class="mb-0" for="car_form_status">Статус</label>
                        <Select2 v-model="status" :options="statuses_select" :id="'car_form_status'" :settings="{width: '100%'}"/>
                        <has-error :form="form" field="status" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-4">
                        <label class="mb-0" :for="'car_form_platform_id' + _uid">Площадка</label>
                        <input v-if="mode === 'edit'" type="text" readonly class="form-control-plaintext" :id="'car_form_platform_id' + _uid" :value="obj && obj.platform ? obj.platform.name : ''">
                        <Select2 v-else v-model="platform_id" :options="platform_select" :id="'car_form_platform_id'" :settings="{width: '100%'}" :disabled="mode === 'edit'"/>
                        <has-error :form="form" field="platform_id" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-4"><label class="mb-0" for="car_form_key_number">Номер ключа на складе</label><input type="text" class="form-control" id="car_form_key_number" v-model="key_number"><has-error :form="form" field="key_number" class="d-block"/></div>
                    <div class="form-group col-xl-6">
                        <label class="mb-0" for="car_form_legal_owner_id">Собственник</label>
                        <CounteragentSelect :filter_platforms="[+platform_id]" id="car_form_legal_owner_id" class="multiselect-bootstrap" v-model="legal_owner_id" :max_height="250" />
                        <has-error :form="form" field="legal_owner_id" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-6">
                        <label class="mb-0" for="car_form_actual_owner_id">
                            <span>Владелец</span>
                            <div class="custom-control custom-switch ml-3 d-inline">
                                <input type="checkbox" class="custom-control-input" :id="'car_form_on_commission' + _uid" v-model="on_commission">
                                <label class="custom-control-label" :for="'car_form_on_commission' + _uid">На комиссии</label>
                            </div>
                        </label>
                        <CarActualOwnerSelect :filter_platforms="[+platform_id]" id="car_form_actual_owner_id" class="multiselect-bootstrap" v-model="actual_owner_id" :max_height="250" />
                        <has-error :form="form" field="actual_owner_id" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-4">
                        <label class="mb-0" for="car_form_purchased_at_date">Дата покупки</label>
                        <div class="form-row">
                            <div class="col-7">
                                <input type="date" class="form-control" id="car_form_purchased_at_date" v-model="purchased_at_date">
                            </div>
                            <div class="col-5">
                                <input type="time" class="form-control" id="car_form_purchased_at_time" v-model="purchased_at_time">
                            </div>
                        </div>
                        <has-error :form="form" field="purchased_at" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-4">
                        <label class="mb-0" for="car_form_arrived_at_date">Дата прихода на склад</label>
                        <div class="form-row">
                            <div class="col-7">
                                <input type="date" class="form-control" id="car_form_arrived_at_date" v-model="arrived_at_date">
                            </div>
                            <div class="col-5">
                                <input type="time" class="form-control" id="car_form_arrived_at_time" v-model="arrived_at_time">
                            </div>
                        </div>
                        <has-error :form="form" field="arrived_at" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-4">
                        <label class="mb-0" for="car_form_sold_at_date">Дата продажи</label>
                        <div class="form-row">
                            <div class="col-7">
                                <input type="date" class="form-control" id="car_form_sold_at_date" v-model="sold_at_date">
                            </div>
                            <div class="col-5">
                                <input type="time" class="form-control" id="car_form_sold_at_time" v-model="sold_at_time">
                            </div>
                        </div>
                        <has-error :form="form" field="sold_at" class="d-block"/>
                    </div>
                    <div v-if="obj && (obj.days_here !== null || obj.days_total !== null)" class="form-group col-xl-12">
                        <span class="text-nowrap">
                            <template v-if="obj.days_here !== null">{{ obj.days_here }}д здесь</template>
                            <template v-if="obj.days_here !== null && obj.days_total !== null"> · </template>
                            <template v-if="obj.days_total !== null"><span :class="{'car-age-total-red': obj.days_total > 90}">{{ obj.days_total }}д всего</span></template>
                        </span>
                    </div>
                    <div class="form-group col-xl-12">
                        <label class="mb-0" for="car_form_complectation_desc">Описание комплектации<BadgeTemp text="new" color="red" to="2022-12-31" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></label>
                        <textarea class="form-control w-100" name="complectation_desc" id="car_form_complectation_desc" rows="2" v-model="complectation_desc"></textarea>
                        <has-error :form="form" field="complectation_desc" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-12">
                        <label class="mb-0" for="car_form_defects_desc">Дефекты и повреждения<BadgeTemp text="new" color="red" to="2022-12-31" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></label>
                        <textarea class="form-control w-100" name="defects_desc" id="car_form_defects_desc" rows="2" v-model="defects_desc"></textarea>
                        <has-error :form="form" field="defects_desc" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-12">
                        <label class="mb-0" for="car_form_comment">Коментарий</label>
                        <textarea class="form-control w-100" name="comment" id="car_form_comment" rows="2" v-model="comment"></textarea>
                        <has-error :form="form" field="comment" class="d-block"/>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="pts" label="ПТС и СТС">
                <div class="form-row">
                    <div class="card-title ml-2">ПТС</div>

                    <div class="form-group mb-0">
                        <div class="custom-controls-stacked d-inline-block ml-2">
                            <label class="custom-control custom-radio custom-control-inline">
                                <input name="pts_type" type="radio" class="custom-control-input" value="electronic" v-model="pts_type">
                                <span class="custom-control-label">ЭПТС</span>
                            </label>
                            <label class="custom-control custom-radio custom-control-inline">
                                <input name="pts_type" type="radio" class="custom-control-input" value="normal" v-model="pts_type">
                                <span class="custom-control-label">ПТС</span>
                            </label>
                        </div>
                        <has-error :form="form" field="pts_type" class="d-block"/>
                    </div>
                    <div class="w-100"></div>
                    <div class="form-group col-xl-1"><label class="mb-0" for="car_form_pts_series">Серия</label><input type="text" class="form-control" id="car_form_pts_series" v-model="pts_series"><has-error :form="form" field="pts_series" class="d-block"/></div>
                    <div class="form-group col-xl-2"><label class="mb-0" for="car_form_pts_number">Номер</label><input type="text" class="form-control" id="car_form_pts_number" v-model="pts_number"><has-error :form="form" field="pts_number" class="d-block"/></div>
                    <div class="form-group col-xl-3">
                        <label class="mb-0">VIN</label>
                        <input type="text" class="form-control" :class="{'is-invalid': vinFormatError}" id="car_form_pts_vin" v-model="pts_vin" :disabled="vin_type === 'absent'" :placeholder="vin_type === 'absent' ? 'ОТСУТСТВУЕТ' : ''" @input="onVinInput">
                        <div class="btn-group btn-group-sm btn-group-toggle d-flex mt-1" data-toggle="buttons">
                            <label class="btn btn-outline-gray" :class="{active: vin_type === 'vin'}">
                                <input type="radio" value="vin" v-model="vin_type"> VIN
                            </label>
                            <label class="btn btn-outline-gray" :class="{active: vin_type === 'absent'}">
                                <input type="radio" value="absent" v-model="vin_type"> Отсутствует
                            </label>
                            <label class="btn btn-outline-gray" :class="{active: vin_type === 'other'}">
                                <input type="radio" value="other" v-model="vin_type"> Другой
                            </label>
                        </div>
                        <div v-if="vinFormatError" class="text-danger small mt-1">{{ vinFormatError }}</div>
                        <has-error :form="form" field="pts_vin" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_brand_model">Марка, Модель ТС</label><input type="text" class="form-control" id="car_form_pts_brand_model" v-model="pts_brand_model"><has-error :form="form" field="pts_brand_model" class="d-block"/></div>
                    <div class="form-group col-xl-2"><label class="mb-0" for="car_form_pts_transport_type">Тип ТС</label><input type="text" class="form-control" id="car_form_pts_transport_type" v-model="pts_transport_type"><has-error :form="form" field="pts_transport_type" class="d-block"/></div>
                    <div class="form-group col-xl-1"><label class="mb-0" for="car_form_pts_transport_category">Катег</label><input type="text" class="form-control" id="car_form_pts_transport_category" v-model="pts_transport_category"><has-error :form="form" field="pts_transport_category" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_engine">Модель, № двигателя</label><input type="text" class="form-control" id="car_form_pts_engine" v-model="pts_engine"><has-error :form="form" field="pts_engine" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_chassis">Шасси №</label><input type="text" class="form-control" id="car_form_pts_chassis" v-model="pts_chassis"><has-error :form="form" field="pts_chassis" class="d-block"/></div>
                    <div class="form-group col-xl-3">
                        <label class="mb-0" for="car_form_pts_body">Кузов №</label>
                        <input type="text" class="form-control" id="car_form_pts_body" v-model="pts_body">
                        <has-error :form="form" field="pts_body" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_color">Цвет</label><input type="text" class="form-control" id="car_form_pts_color" v-model="pts_color"><has-error :form="form" field="pts_color" class="d-block"/></div>
                    <div class="form-group col-xl-2"><label class="mb-0" for="car_form_pts_engine_power">Мощность, л.с.</label><input type="text" class="form-control" id="car_form_pts_engine_power" v-model="pts_engine_power"><has-error :form="form" field="pts_engine_power" class="d-block"/></div>
                    <div class="form-group col-xl-2"><label class="mb-0" for="car_form_pts_engine_volume">Объем двиг., см3</label><input type="text" class="form-control" id="car_form_pts_engine_volume" v-model="pts_engine_volume"><has-error :form="form" field="pts_engine_volume" class="d-block"/></div>
                    <div class="form-group col-xl-2"><label class="mb-0" for="car_form_pts_engine_type">Тип двигателя</label><input type="text" class="form-control" id="car_form_pts_engine_type" v-model="pts_engine_type"><has-error :form="form" field="pts_engine_type" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_ecological_class">Экологический класс</label><input type="text" class="form-control" id="car_form_pts_ecological_class" v-model="pts_ecological_class"><has-error :form="form" field="pts_ecological_class" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_max_weight">Разреш. макс масса, кг</label><input type="text" class="form-control" id="car_form_pts_max_weight" v-model="pts_max_weight"><has-error :form="form" field="pts_max_weight" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_weight_without_load">Масса без нагрузки, кг</label><input type="text" class="form-control" id="car_form_pts_weight_without_load" v-model="pts_weight_without_load"><has-error :form="form" field="pts_weight_without_load" class="d-block"/></div>
                    <div class="form-group col-xl-9"><label class="mb-0" for="car_form_pts_maker">Организация - изготовитель ТС (страна)</label><input type="text" class="form-control" id="car_form_pts_maker" v-model="pts_maker"><has-error :form="form" field="pts_maker" class="d-block"/></div>
                    <div class="form-group col-xl-6"><label class="mb-0" for="car_form_pts_type_approval">Одобрение типа ТС</label><input type="text" class="form-control" id="car_form_pts_type_approval" v-model="pts_type_approval"><has-error :form="form" field="pts_type_approval" class="d-block"/></div>
                    <div class="form-group col-xl-6"><label class="mb-0" for="car_form_pts_exporting_country">Страна вывоза ТС</label><input type="text" class="form-control" id="car_form_pts_exporting_country" v-model="pts_exporting_country"><has-error :form="form" field="pts_exporting_country" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_customs_receipt">Серия, № ТД, ТПО</label><input type="text" class="form-control" id="car_form_pts_customs_receipt" v-model="pts_customs_receipt"><has-error :form="form" field="pts_customs_receipt" class="d-block"/></div>
                    <div class="form-group col-xl-9"><label class="mb-0" for="car_form_pts_customs_restrictions">Таможенные ограничения</label><input type="text" class="form-control" id="car_form_pts_customs_restrictions" v-model="pts_customs_restrictions"><has-error :form="form" field="pts_customs_restrictions" class="d-block"/></div>
                    <div class="form-group col-xl-6"><label class="mb-0" for="car_form_pts_owner">Наименование (ФИО) собственника ТС</label><input type="text" class="form-control" id="car_form_pts_owner" v-model="pts_owner"><has-error :form="form" field="pts_owner" class="d-block"/></div>
                    <div class="form-group col-xl-6"><label class="mb-0" for="car_form_pts_owner_address">Адрес собственника</label><input type="text" class="form-control" id="car_form_pts_owner_address" v-model="pts_owner_address"><has-error :form="form" field="pts_owner_address" class="d-block"/></div>
                    <div class="form-group col-xl-6"><label class="mb-0" for="car_form_pts_issuing_authority">Наименование огранизации, выдавшей паспорт</label><input type="text" class="form-control" id="car_form_pts_issuing_authority" v-model="pts_issuing_authority"><has-error :form="form" field="pts_issuing_authority" class="d-block"/></div>
                    <div class="form-group col-xl-6"><label class="mb-0" for="car_form_pts_issuing_authority_address">Адрес организации, выдавшей паспорт</label><input type="text" class="form-control" id="car_form_pts_issuing_authority_address" v-model="pts_issuing_authority_address"><has-error :form="form" field="pts_issuing_authority_address" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_issue_date">Дата выдачи паспорта</label><input type="date" class="form-control" id="car_form_pts_issue_date" v-model="pts_issue_date"><has-error :form="form" field="pts_issue_date" class="d-block"/></div>
                    <div class="form-group col-xl-9"><label class="mb-0" for="car_form_pts_special_marks">Особые отметки</label><input type="text" class="form-control" id="car_form_pts_special_marks" v-model="pts_special_marks"><has-error :form="form" field="pts_special_marks" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_pts_state_number">Гос номер</label><input type="text" class="form-control" id="car_form_pts_state_number" v-model="pts_state_number"><has-error :form="form" field="pts_state_number" class="d-block"/></div>
                </div>
                <div class="form-row">
                    <div class="card-title ml-2">СТС</div>
                    <div class="w-100"></div>
                    <div class="form-group col-xl-1"><label class="mb-0" for="car_form_sts_series">Серия</label><input type="text" class="form-control" id="car_form_sts_series" v-model="sts_series"><has-error :form="form" field="sts_series" class="d-block"/></div>
                    <div class="form-group col-xl-2"><label class="mb-0" for="car_form_sts_number">Номер</label><input type="text" class="form-control" id="car_form_sts_number" v-model="sts_number"><has-error :form="form" field="sts_number" class="d-block"/></div>
                    <div class="form-group col-xl-6"><label class="mb-0" for="car_form_sts_issuing_authority">Кем выдан</label><input type="text" class="form-control" id="car_form_sts_issuing_authority" v-model="sts_issuing_authority"><has-error :form="form" field="sts_issuing_authority" class="d-block"/></div>
                    <div class="form-group col-xl-3"><label class="mb-0" for="car_form_sts_issue_date">Дата выдачи</label><input type="date" class="form-control" id="car_form_sts_issue_date" v-model="sts_issue_date"><has-error :form="form" field="sts_issue_date" class="d-block"/></div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="files" label="Файлы" v-if="$hasPermissionInterface('car.form.tab_files')">
                <div class="form-row">
                    <div class="card-title ml-2">Файлы</div>
                    <div class="form-group col-xl-12">
                        <label class="mb-0">Фото автомобиля <a class="ml-2" v-if="obj && obj.id && obj.photos.length" target="_blank" :href="'/api/cars/' + obj.id + '/downloadFiles/photos'"><i class="fas fa-download"></i></a></label>
                        <DocumentsUpload :filesModel.sync="photos" :limit="20" />
                        <has-error :form="form" field="photos" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-12">
                        <label class="mb-0">Диагностическая Карта <a class="ml-2" v-if="obj && obj.id && obj.diagnostic_card_files.length" target="_blank" :href="'/api/cars/' + obj.id + '/downloadFiles/diagnostic_card_files'"><i class="fas fa-download"></i></a></label>
                        <DocumentsUpload :filesModel.sync="diagnostic_card_files" :accept="'*/*'" :limit="20" />
                        <has-error :form="form" field="diagnostic_card_files" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-12">
                        <label class="mb-0">ПТС <a class="ml-2" v-if="obj && obj.id && obj.pts_scans.length" target="_blank" :href="'/api/cars/' + obj.id + '/downloadFiles/pts_scans'"><i class="fas fa-download"></i></a></label>
                        <DocumentsUpload :filesModel.sync="pts_scans" :accept="'image/*'" :limit="20" />
                        <has-error :form="form" field="pts_scans" class="d-block"/>
                    </div>
                    <div class="form-group col-xl-12">
                        <label class="mb-0">СТС <a class="ml-2" v-if="obj && obj.id && obj.sts_scans.length" target="_blank" :href="'/api/cars/' + obj.id + '/downloadFiles/sts_scans'"><i class="fas fa-download"></i></a></label>
                        <DocumentsUpload :filesModel.sync="sts_scans" :accept="'image/*'" :limit="20" />
                        <has-error :form="form" field="sts_scans" class="d-block"/>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="operations" label="Операции и расходы" v-if="allowedPlatform && $hasPermissionInterface('car.form.tab_operations') && obj && obj.id && $hasPermission('operations.list.show')">
                <CarOperationsBlock v-if="tab_active === 'operations'" :car_id="obj.id" :car_platform_id="obj.platform_id"/>
            </el-tab-pane>
            <el-tab-pane name="reports" label="Отчеты" v-if="allowedPlatform && obj && obj.id">
                <div v-if="obj.reports">
                    <template v-if="r.status === 'completed'" v-for="r in obj.reports">
                        <div >
                            <template v-if="r.source === 'avtocod'">
                                <div class="d-flex align-items-center">
                                    <div @click="$emit('showReport', r.id)" style="background-color: #067eff;cursor: pointer;padding: 5px;border-radius: 7px;">
                                        <img src="/svg/avtocod.svg" alt="">
                                    </div>
                                    <a class="pl-1" v-if="r.pdf" :href="'/storage' + r.pdf" target="_blank"><i style="color: #F40F02; font-size: 26px" class="far fa-file-pdf"></i></a>
                                </div>
                                <span class="small text-muted pb-2">от {{r.updated_at | formatDateDMYHi}}</span>
                            </template>
                            <template v-if="r.source === 'autoteka'">
                                <div class="d-flex align-items-center">
                                    <a :href="r.web_link" target="_blank" style="background-color: rgb(222, 222, 222);cursor: pointer;padding: 5px;border-radius: 7px;">
                                        <img src="data:image/svg+xml;base64,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" alt="">
                                    </a>
                                    <a class="pl-1" v-if="r.pdf" :href="r.pdf" target="_blank"><i style="color: #F40F02; font-size: 26px" class="far fa-file-pdf"></i></a>
                                    <el-button v-if="remakeReportAutotekaButton" @click="reportRemake(r.id)" class="ml-3" icon="el-icon-refresh" circle></el-button>
                                </div>
                                <span class="small text-muted pb-2">от {{r.updated_at | formatDateDMYHi}}</span>
                            </template>
                        </div>
                    </template>
                </div>
            </el-tab-pane>
        </el-tabs>

        <div class="form-row mt-3">
            <div class="form-group col-12">
                <button v-if="mode === 'create' && $hasPermission('cars.create')" class="btn btn-primary" @click="create">Создать</button>
                <button v-if="mode === 'edit' && $hasPermission('cars.update') && allowedPlatform" class="btn btn-primary" @click="update">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import CounteragentSelect from "../counteragents/CounteragentSelect";
import CarActualOwnerSelect from "../car_actual_owners/CarActualOwnerSelect";
import CarStatusData from "../../plugins/car_status_data";
import DocumentsUpload from "../requests/profiles/DocumentsUpload";
import Form from "vform";
import CarOperationsBlock from "./CarOperationsBlock";
import HelpPopover from "../others/HelpPopover";
import RoleData from "../../plugins/role_data";
import BadgeTemp from "../others/BadgeTemp";
export default {
    name: "CarForm",
    components: {
        BadgeTemp,
        HelpPopover, CarOperationsBlock, DocumentsUpload, CarActualOwnerSelect, CounteragentSelect, Multiselect},
    props: {
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
        obj: {
            type: Object,
            required: false,
            default: null,
        }
    },
    data: () => ({
        brands: [],
        models: [],
        generations: [],
        years: [],
        bodies: [],
        modifications: [],
        complectations: [],

        isLoading: false,
        loadings: {
            brands: false,
            models: false,
            generations: false,
            years: false,
            bodies: false,
            modifications: false,
            complectations: false,
        },
        initialized: false,

        brand_name: null,
        model_name: null,
        generation_name: null,
        body_type: null,
        modification_name: null,
        complectation_name: null,
        gearbox_type: null,
        drive_type: null,
        condition: null,
        mileage: null,
        cost: null,
        cost_increase: null,
        cost_accumulated: null,

        status: null,
        platform_id: null,
        key_number: null,
        legal_owner_id: null,
        actual_owner_id: null,
        on_commission: null,
        purchased_at: null,
        purchased_at_date: null,
        purchased_at_time: null,
        arrived_at: null,
        arrived_at_date: null,
        arrived_at_time: null,
        sold_at: null,
        sold_at_date: null,
        sold_at_time: null,
        complectation_desc: null,
        defects_desc: null,
        comment: null,
        photos: [],
        diagnostic_card_files: [],

        vin_type: 'vin',

        pts_type: null,
        pts_series: null,
        pts_number: null,
        pts_vin: null,
        pts_brand_model: null,
        pts_transport_type: null,
        pts_transport_category: null,
        pts_year: null,
        pts_engine: null,
        pts_chassis: null,
        pts_body: null,
        pts_color: null,
        pts_engine_power: null,
        pts_engine_volume: null,
        pts_engine_type: null,
        pts_ecological_class: null,
        pts_max_weight: null,
        pts_weight_without_load: null,
        pts_maker: null,
        pts_type_approval: null,
        pts_exporting_country: null,
        pts_customs_receipt: null,
        pts_customs_restrictions: null,
        pts_owner: null,
        pts_owner_address: null,
        pts_issuing_authority: null,
        pts_issuing_authority_address: null,
        pts_issue_date: null,
        pts_special_marks: null,
        pts_state_number: null,
        pts_scans: [],

        sts_series: null,
        sts_number: null,
        sts_issuing_authority: null,
        sts_issue_date: null,
        sts_scans: [],

        generation_temp: null,
        modification_temp: null,

        form: new Form({}),
        tab_active: "default",

        remakeReportAutotekaButton: true,
    }),
    mounted() {
        let self = this
        if (this.obj) {
            if (this.obj.brand_name !== undefined) this.brand_name = this.obj.brand_name;
            if (this.obj.model_name !== undefined) this.model_name = this.obj.model_name;
            if (this.obj.generation_name !== undefined) this.generation_temp = {id: this.obj.generation_name, title: this.obj.generation_name};
            if (this.obj.body_type !== undefined) this.body_type = this.obj.body_type;
            if (this.obj.modification_name !== undefined) this.modification_temp = {id: this.obj.modification_name, name: this.obj.modification_name};
            if (this.obj.complectation_name !== undefined) this.complectation_name = this.obj.complectation_name;
            if (this.obj.gearbox_type !== undefined) this.gearbox_type = this.obj.gearbox_type;
            if (this.obj.drive_type !== undefined) this.drive_type = this.obj.drive_type;
            if (this.obj.condition !== undefined) this.condition = this.obj.condition;
            if (this.obj.mileage !== undefined) this.mileage = this.obj.mileage;
            if (this.obj.cost !== undefined) this.cost = this.obj.cost;
            if (this.obj.cost_increase !== undefined) this.cost_increase = this.obj.cost_increase / 100;
            if (this.obj.cost_accumulated !== undefined) this.cost_accumulated = this.obj.cost_accumulated;
            if (this.obj.status !== undefined) this.status = this.obj.status;
            if (this.obj.platform_id !== undefined) this.platform_id = this.obj.platform_id;
            if (this.obj.key_number !== undefined) this.key_number = this.obj.key_number;
            if (this.obj.legal_owner_id !== undefined) this.legal_owner_id = this.obj.legal_owner_id;
            if (this.obj.actual_owner_id !== undefined) this.actual_owner_id = this.obj.actual_owner_id;
            if (this.obj.on_commission !== undefined) this.on_commission = this.obj.on_commission;
            if (this.obj.purchased_at !== undefined && this.obj.purchased_at !== null) {
                this.purchased_at_date = moment(this.obj.purchased_at).format('YYYY-MM-DD');
                this.purchased_at_time = moment(this.obj.purchased_at).format('HH:mm');
            }
            if (this.obj.arrived_at !== undefined && this.obj.arrived_at !== null) {
                this.arrived_at_date = moment(this.obj.arrived_at).format('YYYY-MM-DD');
                this.arrived_at_time = moment(this.obj.arrived_at).format('HH:mm');
            }
            if (this.obj.sold_at !== undefined && this.obj.sold_at !== null) {
                this.sold_at_date = moment(this.obj.sold_at).format('YYYY-MM-DD');
                this.sold_at_time = moment(this.obj.sold_at).format('HH:mm');
            }
            if (this.obj.complectation_desc !== undefined) this.complectation_desc = this.obj.complectation_desc;
            if (this.obj.defects_desc !== undefined) this.defects_desc = this.obj.defects_desc;
            if (this.obj.comment !== undefined) this.comment = this.obj.comment;
            if (this.obj.photos !== undefined && this.obj.photos !== null) this.photos = this.obj.photos;
            if (this.obj.diagnostic_card_files !== undefined && this.obj.diagnostic_card_files !== null) this.diagnostic_card_files = this.obj.diagnostic_card_files;


            if (this.obj.pts_type !== undefined) this.pts_type = this.obj.pts_type;
            if (this.obj.pts_series !== undefined) this.pts_series = this.obj.pts_series;
            if (this.obj.pts_number !== undefined) this.pts_number = this.obj.pts_number;
            if (this.obj.vin_type !== undefined) this.vin_type = this.obj.vin_type || 'vin';
            if (this.obj.pts_vin !== undefined) this.pts_vin = this.obj.pts_vin;
            if (this.obj.pts_brand_model !== undefined) this.pts_brand_model = this.obj.pts_brand_model;
            if (this.obj.pts_transport_type !== undefined) this.pts_transport_type = this.obj.pts_transport_type;
            if (this.obj.pts_transport_category !== undefined) this.pts_transport_category = this.obj.pts_transport_category;
            if (this.obj.pts_year !== undefined) this.pts_year = this.obj.pts_year;
            if (this.obj.pts_engine !== undefined) this.pts_engine = this.obj.pts_engine;
            if (this.obj.pts_chassis !== undefined) this.pts_chassis = this.obj.pts_chassis;
            if (this.obj.pts_body !== undefined) this.pts_body = this.obj.pts_body;
            if (this.obj.pts_color !== undefined) this.pts_color = this.obj.pts_color;
            if (this.obj.pts_engine_power !== undefined) this.pts_engine_power = this.obj.pts_engine_power;
            if (this.obj.pts_engine_volume !== undefined) this.pts_engine_volume = this.obj.pts_engine_volume;
            if (this.obj.pts_engine_type !== undefined) this.pts_engine_type = this.obj.pts_engine_type;
            if (this.obj.pts_ecological_class !== undefined) this.pts_ecological_class = this.obj.pts_ecological_class;
            if (this.obj.pts_max_weight !== undefined) this.pts_max_weight = this.obj.pts_max_weight;
            if (this.obj.pts_weight_without_load !== undefined) this.pts_weight_without_load = this.obj.pts_weight_without_load;
            if (this.obj.pts_maker !== undefined) this.pts_maker = this.obj.pts_maker;
            if (this.obj.pts_type_approval !== undefined) this.pts_type_approval = this.obj.pts_type_approval;
            if (this.obj.pts_exporting_country !== undefined) this.pts_exporting_country = this.obj.pts_exporting_country;
            if (this.obj.pts_customs_receipt !== undefined) this.pts_customs_receipt = this.obj.pts_customs_receipt;
            if (this.obj.pts_customs_restrictions !== undefined) this.pts_customs_restrictions = this.obj.pts_customs_restrictions;
            if (this.obj.pts_owner !== undefined) this.pts_owner = this.obj.pts_owner;
            if (this.obj.pts_owner_address !== undefined) this.pts_owner_address = this.obj.pts_owner_address;
            if (this.obj.pts_issuing_authority !== undefined) this.pts_issuing_authority = this.obj.pts_issuing_authority;
            if (this.obj.pts_issuing_authority_address !== undefined) this.pts_issuing_authority_address = this.obj.pts_issuing_authority_address;
            if (this.obj.pts_issue_date !== undefined) this.pts_issue_date = this.obj.pts_issue_date;
            if (this.obj.pts_special_marks !== undefined) this.pts_special_marks = this.obj.pts_special_marks;
            if (this.obj.pts_state_number !== undefined) this.pts_state_number = this.obj.pts_state_number;
            if (this.obj.pts_scans !== undefined && this.obj.pts_scans !== null) this.pts_scans = this.obj.pts_scans;

            if (this.obj.sts_series !== undefined) this.sts_series = this.obj.sts_series;
            if (this.obj.sts_number !== undefined) this.sts_number = this.obj.sts_number;
            if (this.obj.sts_issuing_authority !== undefined) this.sts_issuing_authority = this.obj.sts_issuing_authority;
            if (this.obj.sts_issue_date !== undefined) this.sts_issue_date = this.obj.sts_issue_date;
            if (this.obj.sts_scans !== undefined && this.obj.sts_scans !== null) this.sts_scans = this.obj.sts_scans;
        }

        if (this.obj && this.obj.id) {
            Echo.private(`car.${this.obj.id}`)
                .listen('.car.recalculated_cost', function (e) {
                    self.cost = e.cost;
                    self.cost_accumulated = e.cost_accumulated;
                })
                .listen('.car.updated', function (e) {
                    Object.entries(e.updated_fields).forEach(([key, value]) => {
                        self.obj[key] = value.new;
                        if (key === 'cost_increase') {
                            self.cost_increase = value.new / 100
                        } else if (key === 'model_name') {
                            setTimeout(() => {self.model_name = value.new;}, 200)
                        } else if (key === 'generation_name') {
                            setTimeout(() => {
                                self.generation_name = value.new;
                                self.generation_temp = {id: value.new, title: value.new};
                            }, 300)
                        } else if (key === 'pts_year') {
                            setTimeout(() => {
                                self.pts_year = value.new;
                            }, 400)
                        } else if (key === 'body_type') {
                            setTimeout(() => {
                                self.body_type = value.new;
                            }, 500)
                        } else if (key === 'modification_name') {
                            setTimeout(() => {
                                self.modification_name = value.new;
                                self.modification_temp = {id: value.new, name: value.new}
                            }, 600)
                        } else if (key === 'complectation_name') {
                            setTimeout(() => {
                                self.complectation_name = value.new;
                            }, 700)
                        } else if (key === 'purchased_at') {
                            self.purchased_at = value.new;
                            self.purchased_at_date = moment(value.new).format('YYYY-MM-DD');
                            self.purchased_at_time = moment(value.new).format('HH:mm');
                        } else if (key === 'arrived_at') {
                            self.arrived_at = value.new;
                            self.arrived_at_date = moment(value.new).format('YYYY-MM-DD');
                            self.arrived_at_time = moment(value.new).format('HH:mm');
                        } else if (key === 'sold_at') {
                            self.sold_at = value.new;
                            self.sold_at_date = moment(value.new).format('YYYY-MM-DD');
                            self.sold_at_time = moment(value.new).format('HH:mm');
                        } else if(self.hasOwnProperty(key)) {
                            self[key] = value.new;
                        }
                        console.log(key, value.new);

                    })
                })
        }

        setTimeout(() => {
            Promise.all([
                this.fetchBrands(),
                (this.brand_name !== null) ? this.fetchModels(this.brand_name) : new Promise((resolve, reject) => {resolve()}),
                (this.brand_name !== null && this.model_name !== null) ? this.fetchGenerations(this.brand_name, this.model_name) : new Promise((resolve, reject) => {resolve()}),
                (this.brand_name !== null && this.model_name !== null && this.generation_name !== null) ? this.fetchYears(this.brand_name, this.model_name, this.generation_name) : new Promise((resolve, reject) => {resolve()}),
                (this.brand_name !== null && this.model_name !== null && this.generation_name !== null && this.pts_year !== null) ? this.fetchBodies(this.brand_name, this.model_name, this.generation_name, this.pts_year) : new Promise((resolve, reject) => {resolve()}),
                (this.brand_name !== null && this.model_name !== null && this.generation_name !== null && this.pts_year !== null && this.body_type !== null) ? this.fetchModifications(this.brand_name, this.model_name, this.generation_name, this.pts_year, this.body_type) : new Promise((resolve, reject) => {resolve()}),
                (this.brand_name !== null && this.model_name !== null && this.generation_name !== null && this.pts_year !== null && this.body_type !== null && this.modification_name && this.modification_temp && this.modification_temp.complectations) ? this.fetchComplectation(this.modification_temp) : new Promise((resolve, reject) => {resolve()}),
            ])
                .then(() => {
                    if (self.generation_name && !self.generation_temp) {
                        self.generation_temp = _.find(self.generation_select, {id: self.generation_name})
                        if (!self.generation_temp) self.generation_temp = {id: self.generation_name, title: self.generation_name}
                    }
                    if (self.modification_name && !self.modification_temp) {
                        self.modification_temp = _.find(self.modification_select, {id: self.modification_name})
                        if (!self.modification_temp) self.modification_temp = {id: self.modification_name, name: self.modification_name}
                    }
                    setTimeout(function () {
                        self.initialized = true;
                    }, 100);
                });
        }, 100);


    },
    beforeDestroy() {
        if (this.obj && this.obj.id) Echo.leave(`car.${this.obj.id}`);
    },
    computed: {
        vinFormatError() {
            if (this.vin_type !== 'vin') return null;
            if (!this.pts_vin) return null;
            if (/^[A-HJ-NPR-Z0-9]{17}$/.test(this.pts_vin)) return null;
            return 'VIN должен содержать 17 символов (латиница и цифры, без I/O/Q)';
        },
        allowedPlatform() {
            return this.$store.getters['auth/user'].allowed_platforms_ids.includes(this.platform_id);
        },
        carAgeText() {
            if (!this.obj) return '';
            let parts = [];
            if (this.obj.days_here !== null && this.obj.days_here !== undefined) parts.push(this.obj.days_here + 'д здесь');
            if (this.obj.days_total !== null && this.obj.days_total !== undefined) parts.push(this.obj.days_total + 'д всего');
            return parts.join(' · ');
        },
        brand_select() {
            let list = _.clone(this.brands);
            if (this.brand_name && this.brands.indexOf(this.brand_name) === -1) list.push(this.brand_name)
            return list.sort();
        },
        model_select() {
            let list = _.clone(this.models);
            if (this.model_name && this.models.indexOf(this.model_name) === -1) list.push(this.model_name)
            return list.sort();
        },
        generation_select() {
            let list = _.map(this.generations, gen => {
                return {
                    id: gen.name,
                    title: gen.name,
                    year_from: gen.year_from,
                    year_to: gen.year_to,
                }
            });
            if (this.generation_temp && !_.find(list, {id: this.generation_temp.id})) list.push(this.generation_temp)
            list = _.sortBy(list, ['title'])
            return list;
        },
        year_select() {
            let list = _.clone(this.years);
            if (this.pts_year && this.years.indexOf(this.pts_year) === -1) list.push(this.pts_year)
            return list.sort();
        },
        body_select() {
            let list = _.clone(this.bodies);
            if (this.body_type && this.bodies.indexOf(this.body_type) === -1) list.push(this.body_type)
            return list.sort();
        },
        modification_select() {
            let list = _.map(this.modifications, mod => {
                mod.id = mod.name;
                return mod;
            });
            if (this.modification_temp && !_.find(list, {id: this.modification_temp.id})) list.push(this.modification_temp)
            list = _.sortBy(list, ['name'])
            return list;
        },
        complectation_select() {
            let list = _.clone(this.complectations);
            if (this.complectation_name && this.complectations.indexOf(this.complectation_name) === -1) list.push(this.complectation_name)
            return list.sort();
        },
        gearbox_type_select() {
            return ['Механика', 'Автомат', 'Робот', 'Вариатор'].sort();
        },
        drive_type_select() {
            return ['Задний', 'Передний', 'Полный'].sort();
        },
        statuses_select() {
            let statuses = CarStatusData.forSelect();
            let user = this.$store.getters['auth/user'];
            statuses = statuses.filter(s => {
                if (this.status === s.id) return true;
                if (this.obj && this.obj.status === 'sold') return false;
                return RoleData.hasPermissionStatus(user, 'car_status', s.id)
            });
            return statuses;
        },
        platform_select () {
            let select = [];
            this.$store.getters['auth/user'].allowed_platforms
                .forEach(function (item) {
                    select.push({
                        id: item.id,
                        text: item.name,
                    })
                });
            select = _.sortBy(select, ['text']);
            return select;
        },
    },
    watch: {
        vin_type(val) {
            if (val === 'absent') this.pts_vin = null;
        },
        brand_name(val) {
            this.onChangeBrand(val);
        },
        model_name(val) {
            this.onChangeModel(val);
        },
        generation_temp(val) {
            this.onChangeGeneration(val);
            this.generation_name = val ? val.id : null;
        },
        pts_year(val) {
            this.onChangeYear(val);
        },
        body_type(val) {
            this.onChangeBody(val);
        },
        modification_temp(val) {
            this.modification_name = val ? val.id : null;
            this.onChangeModification(val);
        },
        complectation_name(val) {
            this.onChangeComplectation(val);
        },
        purchased_at_date(val) {
            if (val) this.purchased_at = moment((val + " " + (this.purchased_at_time ? this.purchased_at_time : '')).trim()).format('YYYY-MM-DD HH:mm:ss');
            if (!val) this.purchased_at = null;
        },
        purchased_at_time(val) {
            if (this.purchased_at_date) this.purchased_at = moment((this.purchased_at_date + " " + (val ? val : '')).trim()).format('YYYY-MM-DD HH:mm:ss');
        },
        arrived_at_date(val) {
            if (val) this.arrived_at = moment((val + " " + (this.arrived_at_time ? this.arrived_at_time : '')).trim()).format('YYYY-MM-DD HH:mm:ss');
            if (!val) this.arrived_at = null;
        },
        arrived_at_time(val) {
            if (this.arrived_at_date) this.arrived_at = moment((this.arrived_at_date + " " + (val ? val : '')).trim()).format('YYYY-MM-DD HH:mm:ss');
        },
        sold_at_date(val) {
            if (val) this.sold_at = moment((val + " " + (this.sold_at_time ? this.sold_at_time : '')).trim()).format('YYYY-MM-DD HH:mm:ss');
            if (!val) this.sold_at = null;
        },
        sold_at_time(val) {
            if (this.sold_at_date) this.sold_at = moment((this.sold_at_date + " " + (val ? val : '')).trim()).format('YYYY-MM-DD HH:mm:ss');
        },
    },
    methods: {
        normalizeVin(val) {
            if (!val) return val;
            const map = {
                'А':'A','В':'B','Е':'E','К':'K','М':'M','Н':'H','О':'O','Р':'P','С':'C','Т':'T','У':'Y','Х':'X',
                'а':'A','в':'B','е':'E','к':'K','м':'M','н':'H','о':'O','р':'P','с':'C','т':'T','у':'Y','х':'X',
            };
            return val.split('').map(c => map[c] !== undefined ? map[c] : c).join('').toUpperCase();
        },
        onVinInput() {
            if (this.vin_type !== 'vin') return;
            const normalized = this.normalizeVin(this.pts_vin);
            if (normalized !== this.pts_vin) this.pts_vin = normalized;
        },
        fetchBrands() {
            let self = this;
            self.loadings.brands = true;
            return axios.post('/api/autocatalog/brands')
                .then(response => {
                    self.brands = _.values(response.data);
                    self.loadings.brands = false;
                })
        },
        fetchModels(brand) {
            let self = this;
            self.loadings.models = true;
            return axios.post('/api/autocatalog/models', {brand: brand})
                .then(response => {
                    self.models = _.values(response.data);
                    self.loadings.models = false;
                })
        },
        fetchGenerations(brand, model) {
            let self = this;
            self.loadings.generations = true;
            return axios.post('/api/autocatalog/generations', {
                brand: brand,
                model: model,
            })
                .then(response => {
                    self.generations = _.values(response.data);
                    self.loadings.generations = false;
                    // if (self.generation_name && !self.generation_temp) {
                    //     self.generation_temp = _.find(self.generation_select, {id: self.generation_name})
                    //     if (!self.generation_temp) self.generation_temp = {id: self.generation_name, title: self.generation_name}
                    // }
                })
        },
        fetchYears(brand, model, generation) {
            let self = this;
            self.loadings.years = true;
            return axios.post('/api/autocatalog/years', {
                brand: brand,
                model: model,
                generation: generation,
            })
                .then(response => {
                    self.years = _.values(response.data);
                    self.loadings.years = false;
                })
        },
        fetchBodies(brand, model, generation, year) {
            let self = this;
            self.loadings.bodies = true;
            return axios.post('/api/autocatalog/bodies', {
                brand: brand,
                model: model,
                generation: generation,
                year: year,
            })
                .then(response => {
                    self.bodies = _.values(response.data);
                    self.loadings.bodies = false;
                })
        },
        fetchModifications(brand, model, generation, year, body) {
            let self = this;
            self.loadings.modifications = true;
            return axios.post('/api/autocatalog/modifications', {
                brand: brand,
                model: model,
                generation: generation,
                year: year,
                body: body,
            })
                .then(response => {
                    self.modifications = _.values(response.data);
                    self.loadings.modifications = false;
                    // if (self.modification_name && !self.modification_temp) {
                    //     self.modification_temp = _.find(self.modification_select, {id: self.modification_name})
                    //     if (!self.modification_temp) self.modification_temp = {id: self.modification_name, name: self.modification_name}
                    // }
                })
        },
        fetchComplectation(temp) {
            let self = this;
            self.complectations = _.values(temp.complectations);
        },

        onChangeBrand(value) {
            if (this.initialized) {
                this.model_name = null;
                this.fetchModels(value);
            }
        },
        onChangeModel(value) {
            if (this.initialized) {
                this.generation_temp = null;
                if (this.brand_name !== null && value !== null) this.fetchGenerations(this.brand_name, value);
                if (value === null) this.generations = [];
            }
        },
        onChangeGeneration(value) {
            if (this.initialized) {
                this.pts_year = null;
                if (this.brand_name !== null && this.model_name !== null && value !== null) this.fetchYears(this.brand_name, this.model_name, value.id);
                if (value === null) this.years = [];
            }
        },
        onChangeYear(value) {
            if (this.initialized) {
                this.body_type = null;
                if (this.brand_name !== null && this.model_name !== null && this.generation_name !== null && value !== null) this.fetchBodies(this.brand_name, this.model_name, this.generation_name, value);
                if (value === null) this.bodies = [];
            }
        },
        onChangeBody(value) {
            if (this.initialized) {
                this.modification_temp = null;
                if (this.brand_name !== null && this.model_name !== null && this.generation_name !== null && this.pts_year !== null && value !== null) this.fetchModifications(this.brand_name, this.model_name, this.generation_name, this.pts_year, value);
                if (value === null) this.modifications = [];
            }
        },
        onChangeModification(value) {
            if (this.initialized) {
                this.complectation_name = null;
                if (this.brand_name !== null && this.model_name !== null && this.generation_name !== null && this.pts_year !== null && this.body_type !== null && this.modification_name && this.modification_temp && this.modification_temp.complectations) this.fetchComplectation(value);
                if (value === null) this.complectations = [];
                if (value !== null) {
                    if (value.drive_type !== undefined) this.drive_type = value.drive_type;
                    if (value.transmission !== undefined) this.gearbox_type = value.transmission;
                    if (value.power !== undefined) this.pts_engine_power = value.power;
                }
            }
        },
        onChangeComplectation(value) {

        },

        addTagBrand(value) {this.brand_name = value},
        addTagModel(value) {this.model_name = value},
        addTagGeneration(value) {this.generation_temp = {id: value, title: value}},
        addTagYear(value) {this.pts_year = value},
        addTagBody(value) {this.body_type = value},
        addTagModification(value) {this.modification_temp = {id: value, name: value}},
        addTagComplectation(value) {this.complectation_name = value},

        validate() {
            this.form = new Form({
                brand_name: this.brand_name,
                model_name: this.model_name,
                generation_name: this.generation_name,
                body_type: this.body_type,
                modification_name: this.modification_name,
                complectation_name: this.complectation_name,
                gearbox_type: this.gearbox_type,
                drive_type: this.drive_type,
                condition: this.condition,
                mileage: this.mileage,
                cost: this.cost,
                cost_increase: this.cost_increase,
                cost_accumulated: this.cost_accumulated,
                status: this.status,
                platform_id: this.platform_id,
                key_number: this.key_number,
                legal_owner_id: this.legal_owner_id,
                actual_owner_id: this.actual_owner_id,
                on_commission: this.on_commission,
                purchased_at: this.purchased_at,
                arrived_at: this.arrived_at,
                sold_at: this.sold_at,
                complectation_desc: this.complectation_desc,
                defects_desc: this.defects_desc,
                comment: this.comment,
                photos: this.photos,
                diagnostic_card_files: this.diagnostic_card_files,
                pts_type: this.pts_type,
                pts_series: this.pts_series,
                pts_number: this.pts_number,
                pts_vin: this.vin_type === 'absent' ? null : this.pts_vin,
                vin_type: this.vin_type,
                pts_brand_model: this.pts_brand_model,
                pts_transport_type: this.pts_transport_type,
                pts_transport_category: this.pts_transport_category,
                pts_year: this.pts_year,
                pts_engine: this.pts_engine,
                pts_chassis: this.pts_chassis,
                pts_body: this.pts_body,
                pts_color: this.pts_color,
                pts_engine_power: this.pts_engine_power,
                pts_engine_volume: this.pts_engine_volume,
                pts_engine_type: this.pts_engine_type,
                pts_ecological_class: this.pts_ecological_class,
                pts_max_weight: this.pts_max_weight,
                pts_weight_without_load: this.pts_weight_without_load,
                pts_maker: this.pts_maker,
                pts_type_approval: this.pts_type_approval,
                pts_exporting_country: this.pts_exporting_country,
                pts_customs_receipt: this.pts_customs_receipt,
                pts_customs_restrictions: this.pts_customs_restrictions,
                pts_owner: this.pts_owner,
                pts_owner_address: this.pts_owner_address,
                pts_issuing_authority: this.pts_issuing_authority,
                pts_issuing_authority_address: this.pts_issuing_authority_address,
                pts_issue_date: this.pts_issue_date,
                pts_special_marks: this.pts_special_marks,
                pts_state_number: this.pts_state_number,
                pts_scans: this.pts_scans,
                sts_series: this.sts_series,
                sts_number: this.sts_number,
                sts_issuing_authority: this.sts_issuing_authority,
                sts_issue_date: this.sts_issue_date,
                sts_scans: this.sts_scans,
            })
            return true;
        },
        create() {
            let self = this;
            this.validate();
            self.isLoading = true;
            this.form.creator_id = this.$store.getters['auth/user'].id
            this.form.post('/api/cars')
                .then(response => {
                    self.$emit('created', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Создано',
                        duration: 2000,
                    });
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка при создании, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        update() {
            let self = this;
            this.validate();
            this.form.put('/api/cars/' + this.obj.id)
                .then(response => {
                    self.$emit('updated', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Сохранено',
                        duration: 2000,
                    });
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка при сохранении, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        reportRemake(id) {
            let self = this;
            axios.post('/api/cars/reports/' + id + '/remake')
                .then(() => {
                    self.remakeReportAutotekaButton = false;
                    self.$message.success({
                        message: 'Обновление отчета по машине поставлено в очередь',
                        duration: 5000,
                    });
                })
        }
    }
}
</script>

<style scoped>
.car-age-total-red {
    color: #791F1F;
}
</style>
